<div class="user-administration-container container" fxLayout="column" fxLayoutGap="15px">
  <div class="page-header container" fxLayout="column" fxLayoutGap="15px" *ngIf="user">
    <div class="user-description" fxLayout="column">
      <div fxLayout="row" fxLayoutGap="15px" fxFlex>
        <mtn-user-initials-avatar [user]="user"></mtn-user-initials-avatar>
        <div fxLayout="column">
          <h1 class="mat-h1 color-primary text-small-caps no-bottom-margin">{{ user.getDisplayName() }}</h1>
          <span class="tab-description color-muted">{{ user.title || ('userAdmin.editToAddTitle' | translate) }}</span>
          <a [href]="'mailto:' + user.email" class="tab-description color-help">{{ user.email }}</a>
          <span class="tab-description color-muted">{{ user.phoneNumber || ('userAdmin.editToAddPhone' | translate) }}</span>
        </div>
        <div fxFlex></div>
        <div>
          <mtn-icon-button [disabled]="true" matTooltip="Feature disabled for Insights entitlements">
            <fa-icon icon="pencil-alt"></fa-icon>
          </mtn-icon-button>
        </div>
        <div>
          <!-- add this for remove disable (click)="openConfirmRemoveAccessWizard()" [disabled]="!user.company?.uuid"
                           [matTooltip]="user.company?.uuid ? ('userAdmin.revokeAccess' | translate) : ('userAdmin.noAccess' | translate)" -->
          <mtn-icon-button color="warn"
         [disabled]="true" matTooltip="Feature disabled for Insights entitlements">
            <fa-icon icon="ban"></fa-icon>
          </mtn-icon-button>
        </div>
      </div>
    </div>
    <hr/>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <div fxLayout="column" fxLayoutGap="30px">
      <mtn-associated-company-card [userProfile]="user" [company]="company"></mtn-associated-company-card>
      <mtn-user-preferences-view [userProfileUuid]="user.uuid" *ngIf="user"></mtn-user-preferences-view>
    </div>
    <div fxFlex fxLayout="column" fxLayoutGap="30px">
      <!-- TODO: Recent activity will go here -->
    </div>
  </div>
</div>
